import { render, staticRenderFns } from "./PlayerTurnOrder.vue?vue&type=template&id=5fb6b28e&scoped=true&"
import script from "./PlayerTurnOrder.vue?vue&type=script&lang=js&"
export * from "./PlayerTurnOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb6b28e",
  null
  
)

export default component.exports